import { Button, InputAdornment, TextField } from "@material-ui/core";
import { Person, VpnKey } from "@material-ui/icons";
import FatButton from "common/components/FatButton/FatButton";
import { SetLoading } from "common/components/Loader/Loader";
import ModalHelper from "common/helpers/modalHelper";
import UserManager from "common/userManager";
import React, { useState } from "react";
import FormError from "./FormError";
import { useAuthStyles } from "./styles";

export default function LoginForm({ notice, onSwitchToRegister }) {
	const styles = useAuthStyles();
	const [username, setUsername] = useState("");
	const [password, setPassword] = useState("");
	const [errorMessage, setErrorMessage] = useState(notice ?? null);

	const onSubmit = (event) => {
		event.preventDefault();
		setErrorMessage(null);

		if (username.length === 0 || password.length === 0) {
			setErrorMessage("Please fill in all fields");
			return;
		}

		SetLoading(true, "Attempting Login...");
		UserManager.login(username, password)
			.then(() => {
				SetLoading(false);
				ModalHelper.closeModal();
				UserManager.redirectAfterLogin();
			})
			.catch((err) => {
				SetLoading(false);
				setErrorMessage(
					err && err.status === 401
						? "Invalid Username or Password provided"
						: "Login failed. Please try again."
				);
			});
	};

	return (
		<form onSubmit={onSubmit}>
			<TextField
				id="username"
				className={styles.field}
				label="Username"
				value={username}
				onChange={(e) => setUsername(e.target.value)}
				variant="outlined"
				fullWidth
				autoFocus
				autoComplete="username"
				InputProps={{
					startAdornment: (
						<InputAdornment position="start">
							<Person />
						</InputAdornment>
					),
				}}
			/>
			<TextField
				id="password"
				className={styles.field}
				label="Password"
				type="password"
				value={password}
				onChange={(e) => setPassword(e.target.value)}
				variant="outlined"
				fullWidth
				autoComplete="current-password"
				InputProps={{
					startAdornment: (
						<InputAdornment position="start">
							<VpnKey />
						</InputAdornment>
					),
				}}
			/>

			<FormError message={errorMessage} />

			<FatButton
				text="Log In"
				type="submit"
				primary
				className={styles.submit}
			/>
			<Button className={styles.secondary} onClick={onSwitchToRegister}>
				Create an account
			</Button>
		</form>
	);
}
